import React, { useState } from 'react';
import { ConfirmDialog } from 'components';
import { deleteSettlement } from '../services/AutoSettlementServices';
import createToast from 'components/Toast/Toast';

const DialogSettlement = (props) => {
  const { onClose, selectedValue, open, setAutoSettle, onEnd = () => {} } = props;
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const handleClose = () => {
    onClose();
  };

  const handleConfirm = async () => {
    try {
      setIsLoadingBtn(true);
      const param = { guildCode: selectedValue };
      await deleteSettlement(param);
      setAutoSettle(false);
      setIsLoadingBtn(false);
      createToast('موفق', 'تسویه خودکار با موفقیت غیر فعال شد!', 'success');

      onEnd();
      onClose();
    } catch (err) {
      setIsLoadingBtn(false);
    }
  };

  return (
    <>
      <ConfirmDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title="تایید لغو درخواست"
        content="از لغو این درخواست اطمینان دارید؟"
        confirmButtonText="بلی"
        cancelButtonProps="خیر"
        loading={isLoadingBtn}
      />
    </>
  );
};

export default DialogSettlement;
